window.addEventListener("DOMContentLoaded", () => {
  let submitButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll(".FormSubmitButton.button") as NodeListOf<HTMLButtonElement>;
  
  // Scroll to the top of the form when the submit button is clicked
  submitButtons.forEach((submitButton: HTMLButtonElement) => {
    if (!!submitButton) {
      submitButton.addEventListener("click", () => {
        let form: HTMLFormElement = submitButton.closest(".EPiServerForms") as HTMLFormElement;
        window.scrollTo({top: form.offsetTop - 200, behavior: 'smooth'})
      });
    }
  });
});